import { render, staticRenderFns } from "./InteractionCard.vue?vue&type=template&id=237f9610&scoped=true"
import script from "./InteractionCard.vue?vue&type=script&lang=js"
export * from "./InteractionCard.vue?vue&type=script&lang=js"
import style0 from "./InteractionCard.vue?vue&type=style&index=0&id=237f9610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f9610",
  null
  
)

export default component.exports